export default __webpack_public_path__ + "static/media/gallery_00.e41a4f85.jpg";